import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export enum ResponseManagementTab {
  RESPONSE_MANAGEMENT,
  LOANS_WAITING_UNDERWRITE_TASK,
}

export const TABS = [
  {
    value: ResponseManagementTab.RESPONSE_MANAGEMENT,
    label: 'Response Management',
  },
  {
    value: ResponseManagementTab.LOANS_WAITING_UNDERWRITE_TASK,
    label: 'Loans Waiting On UW',
  },
];

export enum ResponseManagementCategoryTab {
  UNDERWRITING,
  CLOSING,
  INSURANCE,
  VALUATION,
}

export const RESPONSE_MANAGEMENT_CATEGORY_BY_TAB: Record<ResponseManagementCategoryTab, string> = {
  [ResponseManagementCategoryTab.UNDERWRITING]: 'Underwriting',
  [ResponseManagementCategoryTab.CLOSING]: 'Closing',
  [ResponseManagementCategoryTab.INSURANCE]: 'Insurance',
  [ResponseManagementCategoryTab.VALUATION]: 'Valuation',
};

export const CATEGORY_TABS = [
  {
    value: ResponseManagementCategoryTab.UNDERWRITING,
    label: 'Underwriting',
  },
  {
    value: ResponseManagementCategoryTab.CLOSING,
    label: 'Closing',
  },
  {
    value: ResponseManagementCategoryTab.INSURANCE,
    label: 'Insurance',
  },
  {
    value: ResponseManagementCategoryTab.VALUATION,
    label: 'Valuation',
  },
];

export const DEFAULT_SORT_MODEL = [{ colId: 'noResponseSince', sort: 'asc' }];

export const responseManagementColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'chatRoomName',
    headerName: 'Chat Room',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'messageFrom',
    headerName: 'Message From',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'businessTimeInTask',
    headerName: 'Business Time in Task',
    minWidth: 220,
    ...filterProps(),
  },
  {
    field: 'noResponseSince',
    headerName: 'No Response Since',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'lastMessageSentiment',
    headerName: 'Sentiment',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'primaryCsc',
    headerName: 'Primary CSC',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: 'responseManagementActionsCellRenderer',
    maxWidth: 100,
    sortable: false,
    filter: false,
    pinned: 'right',
    lockPinned: true,
  },
];
